<template>
  <blueprint-wrapper>
    <blueprint-header class="pos-relative">
      <app-header :header-options="headerOptions"/>
    </blueprint-header>
    <blueprint-content>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </blueprint-content>
    <!-- TODO(adam): make footer options so we can remove dashboard layout -->
    <blueprint-footer>
      <app-footer/>
    </blueprint-footer>
  </blueprint-wrapper>
</template>

<script>
import AppHeader from '@/layouts/components/AppHeader';
import AppFooter from '@/layouts/components/AppFooter';
import BlueprintWrapper from '@/components/Blueprint/BlueprintWrapper';
import BlueprintHeader from '@/components/Blueprint/BlueprintHeader';
import BlueprintContent from '@/components/Blueprint/BlueprintContent';
import BlueprintFooter from '@/components/Blueprint/BlueprintFooter';

export default {
  name: 'app-layout',
  components: {
    AppHeader,
    AppFooter,
    BlueprintWrapper,
    BlueprintHeader,
    BlueprintContent,
    BlueprintFooter,
  },
  props: {
    headerOptions: {
      type: Object,
      default: null,
    },
  },
};
</script>
